import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const dashboardPollList = createAsyncThunk('dashboardPoll/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `poll_result`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const submitPollVote = createAsyncThunk('dashboardPoll/vote', async ({ poll_id, option_id }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + `poll_result`,
            data: {
                poll_id,
                option_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const dashboardPoll = createSlice({
    name: 'dashboardPoll',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dashboardPollList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
    }
})

export default dashboardPoll.reducer;